import {
  OTHER_CATEGORIES,
  CATEGORIES_REVERSE,
  DOMAIN_MAP,
  AFFILIATE_ENABLED,
  DOMAIN_AFFILIATE_MAP,
} from '../../../shared/constants';
import { Product, DomainKey } from '../../../shared/types/product';

export function addAdditionalFields(
  product: Product,
  domain: DomainKey
) {
  const copy = { ...product, domain };
  if (copy.image) {
    const imageName = String.fromCharCode.apply('', copy.image);
    copy.imagename = imageName;
    copy.imageurl = `https://images-na.ssl-images-amazon.com/images/I/${imageName}`;
  }
  let category = '';
  if (OTHER_CATEGORIES[domain].includes(Number(copy.rootcat))) {
    category = (CATEGORIES_REVERSE[domain] as any)[1];
  } else {
    category = (CATEGORIES_REVERSE[domain] as any)[copy.rootcat];
  }
  const keepa_sources = [4, 5];
  if (keepa_sources.indexOf(product.source) >= 0 && product.lastupdate) {
    copy.checkeddate = new Date((product.lastupdate + 21564000) * 60000);
  } else if (product.updated_at) {
    copy.checkeddate = new Date(product.updated_at.replace(' ', 'T'));
  }

  copy.showprice = showPrice(copy.checkeddate, domain);
  copy.unpriced = copy.usedprice == null || copy.usedprice === 0;
  copy.category = category;
  copy.displaysavingspercent = Math.floor((copy.savingspercent ?? 0) / 100);
  copy.displaypricedifference = Math.floor((copy.pricedifference ?? 0) / 100);
  copy.displayusedprice = Math.max(0, copy.usedprice / 100.0);
  const amazonDomain = (DOMAIN_MAP as any)[domain] || 'com';

  const affiliateTag = DOMAIN_AFFILIATE_MAP[domain];
  if (AFFILIATE_ENABLED && affiliateTag) {
    copy.amazonlink = `https://www.amazon.${amazonDomain}/dp/${copy.asin}?tag=${affiliateTag}&linkCode=osi&th=1&psc=1`;
  } else {
    copy.amazonlink = `https://www.amazon.${amazonDomain}/dp/${copy.asin}?th=1&psc=1`;
  }
  return copy;
}

function showPrice(date: Date, domain: DomainKey): boolean {
  if(domain != "1") {
    return true;
  }
  let differenceMillis = Math.abs(Date.now() - date.getTime());
  return Math.floor(differenceMillis / (1000 * 60 * 60 * 24)) < 1;
}
